import { Navigate, Route, Routes as RouterRoutes } from 'react-router-dom'

import { AutoApprovalListContainer } from '../../autoApprovalList/AutoApprovalListContainer'
import { AutoRejectionListContainer } from '../../autoRejectionList/AutoRejectionListContainer'
import { AutoRequestRejectionListContainer } from '../../autoRequestRejectionList/AutoRequestRejectionListContainer'
import { ComplianceContainer } from '../../compliance/ComplianceContainer'
import { DonationMatchRequestDetailsContainer } from '../../donationMatchRequest/donationMatchRequest/DonationMatchRequestDetailsContainer'
import { DonationRequestDetailContainer } from '../../donationRequests/donationRequestDetail/DonationRequestDetailContainer'
import { MyAccount } from '../../myAccount/MyAccount'
import { OrganizationsContainer } from '../../organizations/OrganizationsContainer'
import { OrganizationsDetail } from '../../organizations/organizationsDetail/OrganizationsDetail'
import { MilestonesContainer } from '../../organizations/organizationsDetail/milestones/MilestonesContainer'
import { ProgramDetail } from '../../partner/program/ProgramDetail/ProgramDetail'
import { AddNewProgramContainer } from '../../partner/programs/addNewProgram/AddNewProgramContainer'
import { EligibilityCriteriaContainer } from '../../partner/programs/eligibilityCriteria/EligibilityCriteriaContainer'
import { ValidationSubmissionsContainer } from '../../validationSubmissions/ValidationSubmissionsContainer'
import { HeldValidationSubmissionsContainer } from '../../validationSubmissions/heldValidationSubmissions/HeldValidationSubmissionsContainer'
import { ValidationSubmissionDetailsContainer } from '../../validationSubmissions/validationSubmissionDetails/ValidationSubmissionDetailsContainer'
import { NonprofitDetail } from '../../validations/nonprofitDetail/NonprofitDetail'
import { AgentVerificationDetailsContainer } from '../../agentVerification/agentVerificationDetails/AgentVerificationDetailsContainer'
import { GrantsProgramsContainer } from '../../grants/programs/GrantsProgramsContainer'
import { GrantsAssignmentsRulesContainer } from '../../grants/assignmentRules/GrantsAssignmentsRulesContainer'
import { GrantsFormsContainer } from '../../grants/forms/GrantsFormsContainer'
import { GrantsProgramDetailsContainer } from '../../grants/programs/grantsProgramDetails/GrantsProgramDetailsContainer'
import { MonetaryVerificationsTableContainer } from '../../monetaryVerifications/MonetaryVerificationsTableContainer'
import { MonetaryVerificationsDetailsContainer } from '../../monetaryVerifications/monetaryVerificationsDetails/MonetaryVerificationsDetailsContainer'
import { SewaOnboardingContainer } from '../../sewaOnboarding/SewaOnboardingContainer'
import { CreateStaticLinkContainer } from '../../partner/staticLinks/createStaticLink/CreateStaticLinkContainer'
import { EditStaticLinkContainer } from '../../partner/staticLinks/editStaticLink/EditStaticLinkContainer'

import { ActivityCheckContainer } from '@percent/admin-dashboard/app/activityCheck/ActivityCheckContainer'
import { ActivityCheckDetailView } from '@percent/admin-dashboard/app/activityCheck/ActivityCheckDetail/ActivityCheckDetailView'
import { AgentVerificationContainer } from '@percent/admin-dashboard/app/agentVerification/AgentVerificationContainer'
import { BankDetailsContainer } from '@percent/admin-dashboard/app/bankDetails/bankDetailsContainer/BankDetailsContainer'
import { BankDetailsView } from '@percent/admin-dashboard/app/bankDetails/bankDetailsView/BankDetailsView'
import { ClaimsContainer } from '@percent/admin-dashboard/app/claims/ClaimsContainer'
import { DisbursementsContainer } from '@percent/admin-dashboard/app/disbursements/DisbursementsContainer'
import { DisbursementDetailsContainer } from '@percent/admin-dashboard/app/disbursements/disbursementDetails/DisbursementDetailsContainer'
import { DonationMatchRequestsListContainer } from '@percent/admin-dashboard/app/donationMatchRequest/donationMatchRequestsList/DonationMatchRequestsListContainer'
import { DonationRequestsContainer } from '@percent/admin-dashboard/app/donationRequests/DonationRequestsContainer'
import { DonationsContainer } from '@percent/admin-dashboard/app/donations/DonationsContainer'
import { EligibilityContainer } from '@percent/admin-dashboard/app/eligibility/EligibilityContainer'
import { EligibilityDetailsContainer } from '@percent/admin-dashboard/app/eligibility/eligibilityDetail/EligibilityDetailsContainer'
import { EligibilityDetailsContainer as OrganizationEligibilityDetailsContainer } from '@percent/admin-dashboard/app/organizations/organizationsDetail/components/overviewDetails/eligibilityDetail/EligibilityDetailsContainer'
import { PartnerDetail } from '@percent/admin-dashboard/app/partner/partnerDetail/PartnerDetail'
import { PartnerListTable } from '@percent/admin-dashboard/app/partner/partnerListTable/PartnerListTable'
import { RegistriesContainer } from '@percent/admin-dashboard/app/registries/RegistriesContainer'
import { ValidationsContainer } from '@percent/admin-dashboard/app/validations/ValidationsContainer'
import { AccessRoute } from './AccessRoute'
import { AccountsRoute } from './AccountsRoute'
import { FeatureRoute } from './FeatureRoute'
import { DEFAULT_ROUTE } from './default-route'
import { POSTHOG_FEATURE_FLAGS } from '@percent/admin-dashboard/common/hooks/usePostHogFeatureFlag'
import { AccountListContainer } from '@percent/admin-dashboard/app/accounts/AccountListContainer'
import { MemberProfileContainer } from '@percent/admin-dashboard/app/memberProfile'
import { MEMBER_PROFILE_VIEW_PERMISSIONS } from '@percent/admin-dashboard/app/memberProfile/memberProfileAccess'
import { GroupDetailContainer } from '@percent/admin-dashboard/app/accounts/components/groups'
import { RoleDetailContainer } from '@percent/admin-dashboard/app/accounts/components/roles'
import { ServiceDetailContainer } from '@percent/admin-dashboard/app/accounts/components/services'
import { DisbursementDonationsContainer } from '@percent/admin-dashboard/app/disbursements/disbursementDonations/DisbursementDonationsContainer'
import { RalphOracleListContainer } from '@percent/admin-dashboard/app/ralph/oracle/RalphOracleListContainer'
import { RalphOracleDetailContainer } from '@percent/admin-dashboard/app/ralph/oracle/oracleDetail/RalphOracleDetailContainer'
import { useRequiredParams } from '@percent/admin-dashboard/common/hooks'

function NonprofitRedirect() {
  const { id } = useRequiredParams()

  return <Navigate to={`/organizations/${id}`} replace />
}

export function Routes() {
  return (
    <RouterRoutes>
      <Route path="/my-account" element={<MyAccount />} />
      <Route
        path="/accounts/groups/:groupId/*"
        element={
          <AccessRoute permissions="groups:can_view">
            <GroupDetailContainer />
          </AccessRoute>
        }
      />
      <Route
        path="/accounts/services/:serviceId/*"
        element={
          <FeatureRoute flag={POSTHOG_FEATURE_FLAGS.AD_SERVICES}>
            <ServiceDetailContainer />
          </FeatureRoute>
        }
      />
      <Route
        path="/accounts/members/:accountId"
        element={
          <AccessRoute permissions={MEMBER_PROFILE_VIEW_PERMISSIONS.goodstack}>
            <MemberProfileContainer memberType="goodstack" />
          </AccessRoute>
        }
      />
      <Route
        path="/accounts/general/:accountId"
        element={
          <AccessRoute permissions={MEMBER_PROFILE_VIEW_PERMISSIONS.general}>
            <MemberProfileContainer memberType="general" />
          </AccessRoute>
        }
      />
      <Route
        path="/accounts/roles/:domainId"
        element={
          // Same gate as the Roles tab: accounts:can_list (the services-only way into Accounts has no
          // Roles), the flag here and the any-domain role permission inside the container
          <AccessRoute permissions="accounts:can_list">
            <FeatureRoute flag={POSTHOG_FEATURE_FLAGS.AD_ROLES_VIEW}>
              <RoleDetailContainer />
            </FeatureRoute>
          </AccessRoute>
        }
      />
      <Route
        path="/accounts/*"
        element={
          <AccountsRoute>
            <AccountListContainer />
          </AccountsRoute>
        }
      />
      {/* Not guarded: this is DEFAULT_ROUTE, so AccessRoute would redirect a rejected user back to itself */}
      <Route path="/organizations" element={<OrganizationsContainer />} />
      <Route
        path="/organizations/:id/eligibility"
        element={
          <AccessRoute
            permissionEnabledFlag={POSTHOG_FEATURE_FLAGS.INTERNAL_FGA_ORGV_ORGANISATIONS}
            permissions="organisations:can_read"
          >
            <OrganizationEligibilityDetailsContainer />
          </AccessRoute>
        }
      />
      <Route
        path="/organizations/:id/members/:accountId"
        element={
          <AccessRoute permissions={MEMBER_PROFILE_VIEW_PERMISSIONS.organisation}>
            <MemberProfileContainer memberType="organisation" />
          </AccessRoute>
        }
      />
      <Route
        path="/organizations/:id/*"
        element={
          <AccessRoute
            permissionEnabledFlag={POSTHOG_FEATURE_FLAGS.INTERNAL_FGA_ORGV_ORGANISATIONS}
            permissions="organisations:can_read"
          >
            <OrganizationsDetail />
          </AccessRoute>
        }
      />
      <Route path="/nonprofits/:id" element={<NonprofitRedirect />} />
      <Route path="/claims" element={<ClaimsContainer />} />
      <Route
        path="/validations"
        element={
          <AccessRoute
            permissionEnabledFlag="internal_fga_orgv_validation_requests"
            permissions="validation_requests:can_read"
          >
            <ValidationsContainer />
          </AccessRoute>
        }
      />
      <Route
        path="/partners/:id/programs/:configurationId/duplicate-program"
        element={
          <FeatureRoute flag="ad_add_new_program">
            <AddNewProgramContainer />
          </FeatureRoute>
        }
      />
      <Route
        path="/partners/:partnerId/programs/:configurationId/duplicate-eligibility"
        element={
          <FeatureRoute flag="ad_add_new_program">
            <EligibilityCriteriaContainer />
          </FeatureRoute>
        }
      />
      <Route
        path="/partners/:id/programs/add-new-program"
        element={
          <FeatureRoute flag="ad_add_new_program">
            <AddNewProgramContainer />
          </FeatureRoute>
        }
      />
      <Route
        path="/partners/:partnerId/programs/:configurationId/eligibility"
        element={
          <FeatureRoute flag="ad_program_list">
            <EligibilityCriteriaContainer />
          </FeatureRoute>
        }
      />
      <Route
        path="/partners/:id/static-links/create"
        element={
          <AccessRoute
            legacyPermissionFlag="ad_static_links"
            permissionEnabledFlag="internal_fga_orgv_validation_static_links"
            permissions="validation_static_links:can_create"
          >
            <CreateStaticLinkContainer />
          </AccessRoute>
        }
      />
      <Route
        path="/partners/:id/static-links/:staticLinkId/edit"
        element={
          <AccessRoute
            legacyPermissionFlag="ad_static_links"
            permissionEnabledFlag="internal_fga_orgv_validation_static_links"
            permissions="validation_static_links:can_update"
          >
            <EditStaticLinkContainer />
          </AccessRoute>
        }
      />
      <Route path="/partners" element={<PartnerListTable />} />
      <Route
        path="/partners/:partnerId/programs/:id/details"
        element={
          <FeatureRoute flag="ad_program_list">
            <ProgramDetail />
          </FeatureRoute>
        }
      />
      <Route
        path="/partners/:id/members/:accountId"
        element={
          <AccessRoute permissions={MEMBER_PROFILE_VIEW_PERMISSIONS.partner}>
            <MemberProfileContainer memberType="partner" />
          </AccessRoute>
        }
      />
      <Route path="/partners/:id/*" element={<PartnerDetail />} />
      <Route path="/milestones" element={<MilestonesContainer />} />
      <Route
        path="/validations/:id/*"
        element={
          <AccessRoute
            permissionEnabledFlag="internal_fga_orgv_validation_requests"
            permissions="validation_requests:can_read"
          >
            <NonprofitDetail />
          </AccessRoute>
        }
      />
      <Route
        path="/eligibility"
        element={
          <AccessRoute
            permissionEnabledFlag="internal_fga_orgv_eligibility_subscriptions"
            permissions="eligibility_subscriptions:can_read"
          >
            <EligibilityContainer />
          </AccessRoute>
        }
      />
      <Route
        path="/eligibility/:id"
        element={
          <AccessRoute
            permissionEnabledFlag="internal_fga_orgv_eligibility_subscriptions"
            permissions="eligibility_subscriptions:can_read"
          >
            <EligibilityDetailsContainer />
          </AccessRoute>
        }
      />
      <Route path="/compliance" element={<ComplianceContainer />} />
      <Route path="/agent-verification" element={<AgentVerificationContainer />} />
      <Route path="/agent-verification/:id" element={<AgentVerificationDetailsContainer />} />
      <Route
        path="/activity/:id"
        element={
          <AccessRoute permissionEnabledFlag="internal_fga_orgv_activity" permissions="activity:can_read">
            <ActivityCheckDetailView />
          </AccessRoute>
        }
      />
      <Route
        path="/activity"
        element={
          <AccessRoute permissionEnabledFlag="internal_fga_orgv_activity" permissions="activity:can_read">
            <ActivityCheckContainer />
          </AccessRoute>
        }
      />
      <Route
        path="/registries"
        element={
          <AccessRoute
            legacyPermissionFlag="ad_registries"
            permissionEnabledFlag="internal_fga_orgv_registries"
            permissions="registries:can_read"
          >
            <RegistriesContainer />
          </AccessRoute>
        }
      />
      <Route
        path="/bank-details-reviews/:id"
        element={
          <FeatureRoute flag="ad_bank_details_read">
            <BankDetailsView />
          </FeatureRoute>
        }
      />
      <Route
        path="/bank-details-reviews"
        element={
          <FeatureRoute flag="ad_bank_details_read">
            <BankDetailsContainer />
          </FeatureRoute>
        }
      />
      <Route
        path="/disbursements"
        element={
          <FeatureRoute flag="ad_disbursements">
            <DisbursementsContainer />
          </FeatureRoute>
        }
      />
      <Route
        path="/disbursements/:id"
        element={
          <FeatureRoute flag="ad_disbursements">
            <DisbursementDetailsContainer />
          </FeatureRoute>
        }
      />
      <Route
        path="/disbursements/:batchId/donations/:disbursementId"
        element={
          <FeatureRoute flag="ad_disbursements">
            <DisbursementDonationsContainer />
          </FeatureRoute>
        }
      />
      <Route
        path="/donations"
        element={
          <FeatureRoute flag="ad_donations_table">
            <DonationsContainer />
          </FeatureRoute>
        }
      />
      <Route
        path="/donation-match-requests"
        element={
          <FeatureRoute flag="ad_donation_match_requests">
            <DonationMatchRequestsListContainer />
          </FeatureRoute>
        }
      />
      <Route
        path="/donation-match-requests/:donationMatchRequestId"
        element={
          <FeatureRoute flag="ad_donation_match_requests">
            <DonationMatchRequestDetailsContainer />
          </FeatureRoute>
        }
      />
      <Route
        path="/donation-requests"
        element={
          <FeatureRoute flag="ad_donation_requests">
            <DonationRequestsContainer />
          </FeatureRoute>
        }
      />
      <Route
        path="/donation-requests/:id"
        element={
          <FeatureRoute flag="ad_donation_requests">
            <DonationRequestDetailContainer />
          </FeatureRoute>
        }
      />
      <Route
        path="/auto-rejection-list"
        element={
          <AccessRoute
            legacyPermissionFlag="ad_auto_rejection_list"
            permissionEnabledFlag="internal_fga_orgv_agent_verifications_auto_rejection_list"
            permissions="agent_verifications_auto_rejection_list:can_read"
          >
            <AutoRejectionListContainer />
          </AccessRoute>
        }
      />
      <Route
        path="/allow-list"
        element={
          <AccessRoute
            legacyPermissionFlag="ad_auto_allow_list"
            permissionEnabledFlag="internal_fga_orgv_verifications_allow_list"
            permissions="verifications_allow_list:can_read"
          >
            <AutoApprovalListContainer />
          </AccessRoute>
        }
      />
      <Route
        path="/validation-request-block-list"
        element={
          <AccessRoute
            legacyPermissionFlag="ad_vr_block_list"
            permissionEnabledFlag="internal_fga_orgv_validation_request_blocklist"
            permissions="validation_request_blocklist:can_read"
          >
            <AutoRequestRejectionListContainer />
          </AccessRoute>
        }
      />
      <Route
        path="/validation-submissions"
        element={
          <AccessRoute
            permissionEnabledFlag="internal_fga_orgv_validation_submissions"
            permissions="validation_submissions:can_read"
          >
            <ValidationSubmissionsContainer />
          </AccessRoute>
        }
      />
      <Route
        path="/validation-submissions/holds"
        element={
          <AccessRoute legacyPermissionFlag="ad_validation_submission_holds">
            <HeldValidationSubmissionsContainer />
          </AccessRoute>
        }
      />
      <Route
        path="/validation-submissions/:id/*"
        element={
          <AccessRoute
            permissionEnabledFlag="internal_fga_orgv_validation_submissions"
            permissions="validation_submissions:can_read"
          >
            <ValidationSubmissionDetailsContainer />
          </AccessRoute>
        }
      />
      <Route
        path="/grants-programs"
        element={
          <AccessRoute
            legacyPermissionFlag="ad_grant_programs"
            permissionEnabledFlag="internal_fga_grants"
            permissions="grants:can_read_program"
          >
            <GrantsProgramsContainer />
          </AccessRoute>
        }
      />
      <Route
        path="/grants-programs/:id"
        element={
          <AccessRoute
            legacyPermissionFlag="ad_grant_programs"
            permissionEnabledFlag="internal_fga_grants"
            permissions="grants:can_read_program"
          >
            <GrantsProgramDetailsContainer />
          </AccessRoute>
        }
      />
      <Route
        path="/grants-forms/*"
        element={
          <AccessRoute
            legacyPermissionFlag="ad_grant_programs"
            permissionEnabledFlag="internal_fga_grants"
            permissions="grants:can_read_form"
          >
            <GrantsFormsContainer />
          </AccessRoute>
        }
      />
      <Route
        path="/grants-assignment-rules"
        element={
          <AccessRoute
            legacyPermissionFlag="ad_grant_programs"
            permissionEnabledFlag="internal_fga_grants"
            permissions="grants:can_read_program"
          >
            <GrantsAssignmentsRulesContainer />
          </AccessRoute>
        }
      />
      <Route
        path="/sewa-onboarding"
        element={
          <AccessRoute permissions="donations:can_read_sewa">
            <SewaOnboardingContainer />
          </AccessRoute>
        }
      />
      <Route path="/monetary-verifications" element={<MonetaryVerificationsTableContainer />} />
      <Route path="/monetary-verifications/:id" element={<MonetaryVerificationsDetailsContainer />} />
      <Route
        path="/ralph/oracle"
        element={
          <AccessRoute
            legacyPermissionFlag="ad_ralph_oracle"
            permissionEnabledFlag="internal_fga_orgv_ralph_oracle"
            permissions="ralph_oracle:can_read"
          >
            <RalphOracleListContainer />
          </AccessRoute>
        }
      />
      <Route
        path="/ralph/oracle/:country"
        element={
          <AccessRoute
            legacyPermissionFlag="ad_ralph_oracle"
            permissionEnabledFlag="internal_fga_orgv_ralph_oracle"
            permissions="ralph_oracle:can_read"
          >
            <RalphOracleDetailContainer />
          </AccessRoute>
        }
      />
      <Route path="*" element={<Navigate to={DEFAULT_ROUTE} replace />} />
    </RouterRoutes>
  )
}
